export default "__VITE_ASSET__MY$ZOCZN__"